import type { XYCoord } from 'react-dnd';
import { useDragLayer } from 'react-dnd';
import { getZoom, isTransformAffectedByZoom } from '@/utils/scaleWindow';
import style from './index.module.less';

function getItemStyles(
  initialOffset: XYCoord | null,
  currentOffset: XYCoord | null,
  diffPos: XYCoord | null,
) {
  if (!initialOffset || !currentOffset || !diffPos) {
    return {
      display: 'none',
    };
  }

  const { x, y } = initialOffset;


  const s = isTransformAffectedByZoom();
  const zoom = getZoom();
  const bzoom = s ? zoom : 1;

  const transform = `translate(${x / bzoom + diffPos.x / zoom}px, ${y / bzoom + diffPos.y/zoom}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}

export const CustomDragLayer = (props: any) => {
  const { itemType, isDragging, item, initialOffset, currentOffset, offset, initOffset, diffOffset } =
    useDragLayer((monitor) => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      offset: monitor.getClientOffset(),
      initOffset: monitor.getInitialClientOffset(),
      isDragging: monitor.isDragging(),
      diffOffset: monitor.getDifferenceFromInitialOffset()
    }));

  function renderItem(item: any) {
    return <div className={style.option}>{item?.data?.content || item?.data?.data?.content}</div>;
  }

  if (!isDragging) {
    return null;
  }

  return (
    <div className={style.layer}>
      <div
        style={{ ...getItemStyles(initialOffset, currentOffset, diffOffset)}}
      >
        {renderItem(item)}
      </div>
    </div>
  );
};